<template>
  <div>
    <v-app-bar color="white accent-4" app clipped-left clipped-right flat>
      <div
        style="cursor: pointer"
        class="d-flex ml-3 align-center justify-center"
        @click="Home"
      >
        <img src="@/assets/img/logo-survey.png" width="40px" />
        <v-toolbar-title class="ml-2"
          ><span
            class="font-weight-bold"
            style="color: #2d9ed7; font-size: 22px"
            >Survey</span
          ><span
            class="font-weight-bold"
            style="color: #f251a8; font-size: 22px"
            >Me</span
          ></v-toolbar-title
        >
      </div>
      <v-spacer></v-spacer>
      <v-btn
        v-if="trial"
        :style="{ 'text-transform': 'none' }"
        class="white--text mx-2"
        color="#033666"
        @click="Trial"
        >ทดลองใช้งาน</v-btn
      >
      <v-chip v-if="$route.name !== 'survey'" @click="SettingPage" class="mx-1">
        <v-icon size="12" class="pr-2" :color="colorStatus()"
          >mdi-circle</v-icon
        >
        <span class="d-inline-block text-truncate" style="max-width: 100%">
          {{ surveyStatus ? "เปิดการใช้งานแล้ว" : "ยังไม่เปิดการใช้งาน" }}
        </span>
      </v-chip>
      <AllChatmeServices v-if="!webform" />
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-toolbar-title v-on="on">
            <v-btn
              text
              rounded
              dark
              class="px-0 mx-1"
              :style="{ 'text-transform': 'none' }"
              v-if="!webform"
            >
              <v-avatar size="32px" class="mr-2" color="#033666">
                <v-icon>account_circle</v-icon>
              </v-avatar>
              <span style="color: #033666">{{ login_name }}</span>
            </v-btn>
          </v-toolbar-title>
        </template>
        <v-list dense>
          <v-list-item-group color="primary">
            <v-list-item @click="$store.commit('Logout')">
              <v-list-item-icon>
                <v-icon>logout</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Log out</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import AllChatmeServices from "./AllChatmeServices.vue";
export default {
  props: ["webform"],
  components: {
    AllChatmeServices,
  },
  data() {
    return {
      img: true,
      trial: false,
    };
  },
  created() {
    this.$store.dispatch("getTrial").then((resp) => {
      if (resp.data.ableTrial) {
        this.trial = true;
      }
    });
  },
  computed: {
    login_name() {
      return this.$jwtDecode(
        this.$cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_token")
      )
        ? this.$jwtDecode(
            this.$cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_token")
          ).displayName
        : "Client";
    },
    surveyStatus() {
      return this.$store.state.surveystatus;
    },
    SettingAllow() {
      let survey_update = !Object.values(
        this.$store.state.user_permission.survey
      ).every((value) => !value);
      return survey_update;
    },
  },
  methods: {
    SettingPage() {
      if (this.$route.name !== "setting" && this.SettingAllow) {
        this.$router.push({ name: "setting" });
      }
    },
    colorStatus() {
      if (this.surveyStatus) {
        return "#519259";
      } else {
        return "grey";
      }
    },
    Trial() {
      this.$store.dispatch("Trial").then(() => {
        Swal.fire({
          icon: "success",
          text: "เริ่มการทดลองใช้งาน",
          title: "",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          this.$store.dispatch("getTrial");
          this.trial = false;
        });
      });
    },
    Home() {
      if (this.$route.name !== "survey") {
        this.$router.push({
          name: "survey",
        });
      }
    },
  },
};
</script>
